<!-- Tab Header -->
<div style="margin:10px;">
    <b class="modal-headerTitle">Scheduling</b>
</div>

<!-- Classes by Course Properties -->
<ng-container *ngIf="canSeeClassesByCourse">

    <!-- Header -->
    <div class="sis-app-header-label sub-header">
        <span translate>Class Roster</span>
    </div>

    <!-- Main Grid Columns -->
    <div *ngIf="classRosterPreferences" class="drag-container">
        <div style="display: flex">
            <div class="drag-border" style="margin-right: 20px;">
                <div class="drag-header">
                    <span translate>Available Columns</span>
                </div>
                <div style="height:150px;overflow-y:auto">
                    <div id="classRosterMainGridAvailableColumns" style="min-height: 100%" cdkDropList
                        #classRosterMainGridAvailableList="cdkDropList"
                        [cdkDropListData]="classRosterPreferences.AvailableColumns"
                        [cdkDropListConnectedTo]="[classRosterMainGridShownList]"
                        (cdkDropListDropped)="fieldDrop($event)"
                        cdkDropListOrientation="vertical">
                        <div class="drag-item"
                            *ngFor="let column of classRosterPreferences.AvailableColumns; let i = index"
                            [cdkDragData]="column"
                            cdkDrag>
                            {{column}}
                        </div>
                    </div>
                </div>
            </div>
            <div class="drag-border" style="margin-left: 20px;">
                <div class="drag-header">
                    <span translate>Show Columns</span>
                </div>
                <div style="height:150px;overflow-y:auto">
                    <div id="classRosterMainGridShownColumns" cdkDropList style="min-height: 100%"
                        #classRosterMainGridShownList="cdkDropList"
                        [cdkDropListData]="classRosterPreferences.ShowColumns"
                        [cdkDropListConnectedTo]="[classRosterMainGridAvailableList]"
                        (cdkDropListDropped)="fieldDrop($event)"
                        cdkDropListOrientation="vertical">
                        <div class="drag-item"
                            *ngFor="let column of classRosterPreferences.ShowColumns; let i = index"
                            [cdkDragData]="column"
                            cdkDrag>
                            {{column}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div style="font-style:italic;">
            <span translate>Drag names from Available Columns into Show to add them to the grid.</span>
            <br />
            <span translate>Drag within Show to change the order in which the columns are displayed.</span>
        </div>
    </div>

    <!-- Header -->
    <div class="sis-app-header-label sub-header">
        <span translate>Classes by Course</span>
    </div>

    <!-- Main Grid Columns -->
    <div *ngIf="classesByCoursePreferences" class="drag-container">
        <div style="display: flex">
            <div class="drag-border" style="margin-right: 20px;">
                <div class="drag-header">
                    <span translate>Available Main Grid Columns</span>
                </div>
                <div style="height:150px;overflow-y:auto">
                    <div id="classesByCourseMainGridAvailableColumns" style="min-height: 100%" cdkDropList
                        #classesByCourseMainGridAvailableList="cdkDropList"
                        [cdkDropListData]="classesByCoursePreferences.AvailableMainGridColumns"
                        [cdkDropListConnectedTo]="[classesByCourseMainGridShownList]"
                        (cdkDropListDropped)="fieldDrop($event)"
                        cdkDropListOrientation="vertical">
                        <div class="drag-item"
                            *ngFor="let column of classesByCoursePreferences.AvailableMainGridColumns; let i = index"
                            [cdkDragData]="column" cdkDrag>
                            {{column}}
                        </div>
                    </div>
                </div>
            </div>
            <div class="drag-border" style="margin-left: 20px;">
                <div class="drag-header">
                    <span translate>Show Main Grid Columns</span>
                </div>
                <div style="height:150px;overflow-y:auto">
                    <div id="classesByCourseMainGridShownColumns" cdkDropList style="min-height: 100%"
                        #classesByCourseMainGridShownList="cdkDropList"
                        [cdkDropListData]="classesByCoursePreferences.ShowMainGridColumns"
                        [cdkDropListConnectedTo]="[classesByCourseMainGridAvailableList]"
                        (cdkDropListDropped)="fieldDrop($event)" cdkDropListOrientation="vertical">
                        <div class="drag-item"
                            *ngFor="let column of classesByCoursePreferences.ShowMainGridColumns; let i = index"
                            [cdkDragData]="column" cdkDrag>
                            {{column}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div style="font-style:italic;">
            <span translate>Drag names from Available Columns into Show to add them to the grid.</span>
            <br />
            <span translate>Drag within Show to change the order in which the columns are displayed.</span>
        </div>
    </div>

    <!-- Sections Columns -->
    <div *ngIf="classesByCoursePreferences" class="drag-container">
        <div style="display: flex">
            <div class="drag-border" style="margin-right: 20px;">
                <div class="drag-header">
                    <span translate>Available Sub Grid Columns</span>
                </div>
                <div style="height:150px;overflow-y:auto">
                    <div id="classesByCourseSubGridAvailableColumns" style="min-height: 100%" cdkDropList
                        #classesByCourseSubGridAvailableColumns="cdkDropList"
                        [cdkDropListData]="classesByCoursePreferences.AvailableSubGridColumns"
                        [cdkDropListConnectedTo]="[classesByCourseSubGridShownColumns]"
                        (cdkDropListDropped)="fieldDrop($event)">
                        <div class="drag-item"
                            *ngFor="let column of classesByCoursePreferences.AvailableSubGridColumns; let i = index"
                            [cdkDragData]="column" cdkDrag>
                            {{column}}
                        </div>
                    </div>
                </div>
            </div>
            <div class="drag-border" style="margin-left: 20px;">
                <div class="drag-header">
                    <span translate>Show Sub Grid Columns</span>
                </div>
                <div style="height:150px;overflow-y:auto">
                    <div id="classesByCourseSubGridShownColumns" style="min-height: 100%" cdkDropList
                        #classesByCourseSubGridShownColumns="cdkDropList"
                        [cdkDropListData]="classesByCoursePreferences.ShowSubGridColumns"
                        [cdkDropListConnectedTo]="[classesByCourseSubGridAvailableColumns]"
                        (cdkDropListDropped)="fieldDrop($event)">
                        <div class="drag-item"
                            *ngFor="let column of classesByCoursePreferences.ShowSubGridColumns; let i = index"
                            [cdkDragData]="column" cdkDrag>
                            {{column}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div style="font-style:italic;">
            <span translate>Drag names from Available Columns into Show to add them to the grid.</span>
            <br />
            <span translate>Drag within Show to change the order in which the columns are displayed.</span>
        </div>
    </div>
</ng-container>

<!-- Master Scheduling Properties -->
<ng-container *ngIf="canSeeMasterSchedule && !masterScheduleKendoGrid">

    <!-- Header -->
    <div class="sis-app-header-label sub-header">
        <span translate>Master Schedule</span>
    </div>

    <!-- Class Columns -->
    <div *ngIf="masterSchedulePreferences" class="drag-container">
        <div style="display: flex">
            <div class="drag-border" style="margin-right: 20px;">
                <div class="drag-header">
                    <span translate>Available Class Columns</span>
                </div>
                <div style="height:150px;overflow-y:auto">
                    <div id="masterScheduleClassAvailableColumns" style="min-height: 100%" cdkDropList
                        #masterScheduleClassAvailableList="cdkDropList"
                        [cdkDropListData]="masterSchedulePreferences.AvailableClassColumns"
                        [cdkDropListConnectedTo]="[masterScheduleClassShownList]"
                        (cdkDropListDropped)="fieldDrop($event)" cdkDropListOrientation="vertical">
                        <div class="drag-item"
                            *ngFor="let column of masterSchedulePreferences.AvailableClassColumns; let i = index"
                            [cdkDragData]="column" cdkDrag>
                            {{column}}
                        </div>
                    </div>
                </div>
            </div>
            <div class="drag-border" style="margin-left: 20px;">
                <div class="drag-header">
                    <span translate>Show Class Columns</span>
                </div>
                <div style="height:150px;overflow-y:auto">
                    <div id="masterScheduleClassShownColumns" cdkDropList style="min-height: 100%"
                        #masterScheduleClassShownList="cdkDropList"
                        [cdkDropListData]="masterSchedulePreferences.ShownClassColumns"
                        [cdkDropListConnectedTo]="[masterScheduleClassAvailableList]"
                        (cdkDropListDropped)="fieldDrop($event)" cdkDropListOrientation="vertical">
                        <div class="drag-item"
                            *ngFor="let column of masterSchedulePreferences.ShownClassColumns; let i = index"
                            [cdkDragData]="column" cdkDrag>
                            {{column}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div style="font-style:italic;">
            <span translate>Drag names from Available Columns into Show to add them to the grid.</span>
            <br />
            <span translate>Drag within Show to change the order in which the columns are displayed.</span>
        </div>
    </div>

    <!-- Sections Columns -->
    <div *ngIf="masterSchedulePreferences" class="drag-container">
        <div style="display: flex">
            <div class="drag-border" style="margin-right: 20px;">
                <div class="drag-header">
                    <span translate>Available Section Columns</span>
                </div>
                <div style="height:150px;overflow-y:auto">
                    <div id="masterScheduleSectionAvailableColumns" style="min-height: 100%" cdkDropList
                        #masterScheduleSectionAvailableList="cdkDropList"
                        [cdkDropListData]="masterSchedulePreferences.AvailableSectionColumns"
                        [cdkDropListConnectedTo]="[masterScheduleSectionShownList]"
                        (cdkDropListDropped)="fieldDrop($event)">
                        <div class="drag-item"
                            *ngFor="let column of masterSchedulePreferences.AvailableSectionColumns; let i = index"
                            [cdkDragData]="column" cdkDrag>
                            {{column}}
                        </div>
                    </div>
                </div>
            </div>
            <div class="drag-border" style="margin-left: 20px;">
                <div class="drag-header">
                    <span translate>Show Section Columns</span>
                </div>
                <div style="height:150px;overflow-y:auto">
                    <div id="masterScheduleSectionShownColumns" style="min-height: 100%" cdkDropList
                        #masterScheduleSectionShownList="cdkDropList"
                        [cdkDropListData]="masterSchedulePreferences.ShownSectionColumns"
                        [cdkDropListConnectedTo]="[masterScheduleSectionAvailableList]"
                        (cdkDropListDropped)="fieldDrop($event)">
                        <div class="drag-item"
                            *ngFor="let column of masterSchedulePreferences.ShownSectionColumns; let i = index"
                            [cdkDragData]="column" cdkDrag>
                            {{column}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div style="font-style:italic;">
            <span translate>Drag names from Available Columns into Show to add them to the grid.</span>
            <br />
            <span translate>Drag within Show to change the order in which the columns are displayed.</span>
        </div>
    </div>
</ng-container>

<!-- Period Statistics -->
<ng-container *ngIf="canSeePeriodStatistics">

    <!-- Header -->
    <div class="sis-app-header-label sub-header">
        <span translate>Period Statistics</span>
    </div>

    <!-- Fields -->
    <div *ngIf="periodStatisticsPreferences" class="drag-container">
        <div style="display: flex">
            <div class="drag-border" style="margin-right: 20px;">
                <div class="drag-header">
                    <span translate>Available Statistics</span>
                </div>
                <div style="height:150px;overflow-y:auto">
                    <div id="periodStatisticsAvailableFields" style="min-height: 100%" cdkDropList
                        #periodStatisticsAvailableFields="cdkDropList"
                        [cdkDropListData]="periodStatisticsPreferences.AvailableFields"
                        [cdkDropListConnectedTo]="[periodStatisticsShownFields]"
                        (cdkDropListDropped)="fieldDrop($event)" cdkDropListOrientation="vertical">
                        <div class="drag-item"
                            *ngFor="let field of periodStatisticsPreferences.AvailableFields; let i = index"
                            [cdkDragData]="field" cdkDrag>
                            {{field}}
                        </div>
                    </div>
                </div>
            </div>
            <div class="drag-border" style="margin-left: 20px;">
                <div class="drag-header">
                    <span translate>Show</span>
                </div>
                <div style="height:150px;overflow-y:auto">
                    <div id="periodStatisticsShownFields" cdkDropList style="min-height: 100%"
                        #periodStatisticsShownFields="cdkDropList"
                        [cdkDropListData]="periodStatisticsPreferences.ShownFields"
                        [cdkDropListConnectedTo]="[periodStatisticsAvailableFields]"
                        (cdkDropListDropped)="fieldDrop($event)" cdkDropListOrientation="vertical">
                        <div class="drag-item"
                            *ngFor="let field of periodStatisticsPreferences.ShownFields; let i = index"
                            [cdkDragData]="field" cdkDrag>
                            {{field}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div style="font-style:italic;">
            <span translate>Drag names from Available Statistics into Show to add them to the grid.</span>
            <br />
            <span translate>Drag within Show to change the order in which the fields are displayed.</span>
        </div>
    </div>
</ng-container>

<!-- Room Scheduling Settings -->
<ng-container *ngIf="canSeeRoomSchedulingSettings">

    <!-- Header -->
    <div class="sis-app-header-label sub-header">
        <span translate>Room Scheduling Settings</span>
    </div>

    <!-- Fields -->
    <div *ngIf="roomSchedulingSettingsPreferences" class="drag-container">
        <div style="display: flex">
            <div class="drag-border" style="margin-right: 20px;">
                <div class="drag-header">
                    <span translate>Available Columns</span>
                </div>
                <div style="height:150px;overflow-y:auto">
                    <div id="roomSchedulingSettingsAvailableColumns" style="min-height: 100%" cdkDropList
                        #roomSchedulingSettingsAvailableColumns="cdkDropList"
                        [cdkDropListData]="roomSchedulingSettingsPreferences.AvailableColumns"
                        [cdkDropListConnectedTo]="[roomSchedulingSettingsShownColumns]"
                        (cdkDropListDropped)="fieldDrop($event)" cdkDropListOrientation="vertical">
                        <div class="drag-item"
                            *ngFor="let field of roomSchedulingSettingsPreferences.AvailableColumns; let i = index"
                            [cdkDragData]="field" cdkDrag>
                            {{field}}
                        </div>
                    </div>
                </div>
            </div>
            <div class="drag-border" style="margin-left: 20px;">
                <div class="drag-header">
                    <span translate>Show Columns</span>
                </div>
                <div style="height:150px;overflow-y:auto">
                    <div id="roomSchedulingSettingsShownColumns" cdkDropList style="min-height: 100%"
                        #roomSchedulingSettingsShownColumns="cdkDropList"
                        [cdkDropListData]="roomSchedulingSettingsPreferences.ShowColumns"
                        [cdkDropListConnectedTo]="[roomSchedulingSettingsAvailableColumns]"
                        (cdkDropListDropped)="fieldDrop($event)" cdkDropListOrientation="vertical">
                        <div class="drag-item"
                            *ngFor="let field of roomSchedulingSettingsPreferences.ShowColumns; let i = index"
                            [cdkDragData]="field" cdkDrag>
                            {{field}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div style="font-style:italic;">
            <span translate>Drag names from Available Columns into Show to add them to the grid.</span>
            <br />
            <span translate>Drag within Show to change the order in which the fields are displayed.</span>
        </div>
    </div>
</ng-container>

<!-- Schedule Student List -->
<ng-container *ngIf="canSeeScheduleStudentList">

    <!-- Header -->
    <div class="sis-app-header-label sub-header">
        <span translate>Schedule Student List</span>
    </div>

    <!-- Slots -->
    <div *ngIf="scheduleStudentListPreferences" class="drag-container">
        <div style="display: flex">
            <div class="drag-border" style="margin-right: 20px;">
                <div class="drag-header">
                    <span translate>Available Slots</span>
                </div>
                <div style="height:150px;overflow-y:auto">
                    <div id="scheduleStudentListAvailableSlots" style="min-height: 100%" cdkDropList
                        #scheduleStudentListAvailableSlots="cdkDropList"
                        [cdkDropListData]="scheduleStudentListPreferences.AvailableSlots"
                        [cdkDropListConnectedTo]="[scheduleStudentListShowSchedulingSlots]"
                        (cdkDropListDropped)="fieldDrop($event)" cdkDropListOrientation="vertical">
                        <div class="drag-item"
                            *ngFor="let slot of scheduleStudentListPreferences.AvailableSlots; let i = index"
                            [cdkDragData]="slot" cdkDrag>
                            {{slot}}
                        </div>
                    </div>
                </div>
            </div>
            <div class="drag-border" style="margin-left: 20px;">
                <div class="drag-header">
                    <span translate>Show Scheduling Slots</span>
                </div>
                <div style="height:150px;overflow-y:auto">
                    <div id="scheduleStudentListShowSchedulingSlots" cdkDropList style="min-height: 100%"
                        #scheduleStudentListShowSchedulingSlots="cdkDropList"
                        [cdkDropListData]="scheduleStudentListPreferences.ShowSchedulingSlots"
                        [cdkDropListConnectedTo]="[scheduleStudentListAvailableSlots]"
                        (cdkDropListDropped)="fieldDrop($event)" cdkDropListOrientation="vertical">
                        <div class="drag-item"
                            *ngFor="let slot of scheduleStudentListPreferences.ShowSchedulingSlots; let i = index"
                            [cdkDragData]="slot" cdkDrag>
                            {{slot}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div style="font-style:italic;">
            <span translate>Drag names from Available Slots into Show to add them to the grid.</span>
            <br />
            <span translate>Drag within Show to change the order in which the fields are displayed.</span>
        </div>
    </div>

    <!-- Main Grid Columns -->
    <div *ngIf="scheduleStudentListPreferences" class="drag-container">
        <div style="display: flex">
            <div class="drag-border" style="margin-right: 20px;">
                <div class="drag-header">
                    <span translate>Available Main Grid Columns</span>
                </div>
                <div style="height:150px;overflow-y:auto">
                    <div id="scheduleStudentListAvailableMainGridColumns" style="min-height: 100%" cdkDropList
                        #scheduleStudentListAvailableMainGridColumns="cdkDropList"
                        [cdkDropListData]="scheduleStudentListPreferences.AvailableMainGridColumns"
                        [cdkDropListConnectedTo]="[scheduleStudentListShowMainGridColumns]"
                        (cdkDropListDropped)="fieldDrop($event)" cdkDropListOrientation="vertical">
                        <div class="drag-item"
                            *ngFor="let column of scheduleStudentListPreferences.AvailableMainGridColumns; let i = index"
                            [cdkDragData]="column" cdkDrag>
                            {{column}}
                        </div>
                    </div>
                </div>
            </div>
            <div class="drag-border" style="margin-left: 20px;">
                <div class="drag-header">
                    <span translate>Show Main Grid Columns</span>
                </div>
                <div style="height:150px;overflow-y:auto">
                    <div id="scheduleStudentListShowMainGridColumns" cdkDropList style="min-height: 100%"
                        #scheduleStudentListShowMainGridColumns="cdkDropList"
                        [cdkDropListData]="scheduleStudentListPreferences.ShowMainGridColumns"
                        [cdkDropListConnectedTo]="[scheduleStudentListAvailableMainGridColumns]"
                        (cdkDropListDropped)="fieldDrop($event)" cdkDropListOrientation="vertical">
                        <div class="drag-item"
                            *ngFor="let column of scheduleStudentListPreferences.ShowMainGridColumns; let i = index"
                            [cdkDragData]="column" cdkDrag>
                            {{column}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div style="font-style:italic;">
            <span translate>Drag names from Available Columns into Show to add them to the grid.</span>
            <br />
            <span translate>Drag within Show to change the order in which the fields are displayed.</span>
        </div>
    </div>

    <!-- Sub Grid Columns -->
    <div *ngIf="scheduleStudentListPreferences" class="drag-container">
        <div style="display: flex">
            <div class="drag-border" style="margin-right: 20px;">
                <div class="drag-header">
                    <span translate>Available Add Student to Sections Grid Columns</span>
                </div>
                <div style="height:150px;overflow-y:auto">
                    <div id="scheduleStudentListAvailableSubGridColumns" style="min-height: 100%" cdkDropList
                        #scheduleStudentListAvailableSubGridColumns="cdkDropList"
                        [cdkDropListData]="scheduleStudentListPreferences.AvailableSubGridColumns"
                        [cdkDropListConnectedTo]="[scheduleStudentListShowSubGridColumns]"
                        (cdkDropListDropped)="fieldDrop($event)" cdkDropListOrientation="vertical">
                        <div class="drag-item"
                            *ngFor="let column of scheduleStudentListPreferences.AvailableSubGridColumns; let i = index"
                            [cdkDragData]="column" cdkDrag>
                            {{column}}
                        </div>
                    </div>
                </div>
            </div>
            <div class="drag-border" style="margin-left: 20px;">
                <div class="drag-header">
                    <span translate>Show Add Student to Sections Grid Columns</span>
                </div>
                <div style="height:150px;overflow-y:auto">
                    <div id="scheduleStudentListShowSubGridColumns" cdkDropList style="min-height: 100%"
                        #scheduleStudentListShowSubGridColumns="cdkDropList"
                        [cdkDropListData]="scheduleStudentListPreferences.ShowSubGridColumns"
                        [cdkDropListConnectedTo]="[scheduleStudentListAvailableSubGridColumns]"
                        (cdkDropListDropped)="fieldDrop($event)" cdkDropListOrientation="vertical">
                        <div class="drag-item"
                            *ngFor="let column of scheduleStudentListPreferences.ShowSubGridColumns; let i = index"
                            [cdkDragData]="column" cdkDrag>
                            {{column}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div style="font-style:italic;">
            <span translate>Drag names from Available Columns into Show to add them to the grid.</span>
            <br />
            <span translate>Drag within Show to change the order in which the fields are displayed.</span>
        </div>
    </div>
</ng-container>
